export enum LogoutReason {
  LoginFailure = 'login-failure',
  IdleTimeExpiration = 'session-timeout',
  Manual = 'manual'
}
